<template>
    <ul class="months-container">
        <li class="actions">
            <router-link :to="{query: {year_month: dayjs().format('YYYY-MM-DD')}}">
                <svg-icon icon="calendar-check"/>
            </router-link>
        </li>
        <li class="actions">
            <a href="javascript:void(0)" @click="navigate(false)">
                <svg-icon icon="chevron-left"/>
            </a>
        </li>
        <li v-for="m in months"
            :key="m.format('MYYYY')"
            :class="{active: selectedDate.isSame(m, 'month')}">

            <router-link :to="{query: {year_month: m.startOf('month').format('YYYY-MM-DD')}}"
               @click="selectMonth(m)">
                <span class="month">{{m.format('MMM')}}</span>
                <span class="year">{{m.format('YYYY')}}</span>
            </router-link>
        </li>
        <li class="actions">
            <a href="javascript:void(0)" @click="navigate(true)">
                <svg-icon icon="chevron-right"/>
            </a>
        </li>
    </ul>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        name: "MonthNav",
        props: {
            month: {
                type: String,
                required: true,
                validator: val => /\d{4}-\d{2}-\d{2}/.test(val)
            }
        },
        data() {
            return {
                selectedDate: dayjs(),
                months: [],
                dayjs: dayjs
            }
        },
        methods: {
            selectMonth(d) {
                this.selectedDate = d;
            },
            navigate(isUp) {
                if (isUp) {
                    this.$delete(this.months, 0);
                    this.months.push(this.months[this.months.length - 1].add(1, 'month'));
                } else {
                    this.$delete(this.months, this.months.length - 1);
                    this.months.splice(0, 0, this.months[0].subtract(1, 'month'));
                }
            },
            build(date = dayjs()) {
                this.months = [];
                this.selectedDate = date.clone();
                date = date.subtract(3, 'month');
                for(let i = 0; i < 7; i++) {
                    this.months.push(date.clone());
                    date = date.add(1, 'month');
                }
            }
        },
        mounted() {
            this.build(dayjs(this.month))
        },
        watch: {
            month(newVal) {
                const d = dayjs(newVal);

                if (this.months.filter(m => d.isSame(m, 'month') && d.isSame(m, 'year')).length === 0)
                    this.build(d);

                this.selectedDate = d;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/variables";
    .months-container{
        list-style: none;
        margin: 0;
        padding: 0;
        display: grid;
        grid-template-columns: repeat(10, 1fr);
        column-gap: 5px;
        justify-items: center;
        align-items: center;
        width: 400px;
        max-width: 400px;

        li {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            border-radius: 3px;

            &.active {
                a {
                    border-top: 3px solid $theme_color_one;
                    color: $theme_color_one;
                }
            }

            &:hover:not(.active) {
                a {
                    color: $theme_color_six;
                }
            }

            &.actions {
                transition: background-color .4s ease;
                background-color: $theme_color_five;
                a {
                    border-top: 3px solid transparent;
                    color: #fff;
                }
                &:hover {
                    background-color: $theme_color_one;

                    a {
                        border-top: 3px solid transparent;
                        color: #fff;
                    }
                }
            }

            a {
                border-top: 3px solid #fff;
                color: $theme_color_five;
                text-decoration: none;
                text-align: center;
                font-weight: 700;
                transition: color .2s ease;
                font-size: .8em;

                svg {
                    height: 1.8em;
                    width: 1.8em;
                }

                .month{
                    display: block;
                    text-transform: uppercase;
                }
                .year {
                    display: block;
                }
            }
        }
    }

    @media (max-width: 576px) {
        .months-container{
            width: 100%;
            max-width: 100%;
        }
    }
</style>
